export function track(event, parameters = {}) {
  if (typeof window.gtag === "function")
    window.gtag("event", event, parameters);
}
